import { useLocation } from 'react-router';
import { BasePageProps } from '../../layouts/base-layout';
import { withAuth } from '../../components/hoc/with-auth';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useClearAdvisories } from '../../hooks/use-advisories';
import { getApplicationPaths } from '../../app-context/accounts-context';
import { LOGIN_CONSTANTS } from '../../model/constants';
import { Nullable } from 'gocclr-shared-ui/dist/helpers';
import Skeleton from 'react-loading-skeleton';
import { Large } from '../../styles/bootstrap-breakpoints';
import { MediaQuery } from 'gocclr-shared-ui/dist/elements/media-query';
import AcknowledgementTermsAndConditions from '../../components/acknowledgement-terms-and-conditions/acknowledgement-terms-and-conditions';

const MFContainer = styled.div`
  margin-left: 45%;
  margin-right: 45%;
`;

const ButtonContainer = styled.div`
  margin-left: 10%;
  margin-right: 10%;
`;

const DesktopDashboardSkeleton = () => (<Skeleton height={70} enableAnimation={true} borderRadius={0} style={{ margin: '16px 8% 0', width: '84%' }} />);
const MobileDashboardSkeleton = () => (<Skeleton height={194} enableAnimation={true} borderRadius={'0.5rem'} style={{ margin: '1rem auto 0.5rem 1rem', width: '92%' }} />);

export interface PostLoginProps extends BasePageProps { }

export interface PostLoginLocationState {
    returnUrl?: string;
    isOwnerOrManager?: boolean;
}

export function PostLogin(props: PostLoginProps) {
    const location = useLocation();
    const locationState = (location.state as PostLoginLocationState) || {};
    const isOwnerOrManagerState = locationState?.isOwnerOrManager || false;
    const returnUrl = locationState.returnUrl || LOGIN_CONSTANTS.DEFAULT_RETURN_URL;
    const formRef = useRef<Nullable<HTMLFormElement>>(null);

    useClearAdvisories(props.advisoriesApi);

    useEffect(() => {
        if (formRef.current && !isOwnerOrManagerState) {
            formRef.current.submit();
        }
    }, [returnUrl, isOwnerOrManagerState]);

    const applicationPaths = getApplicationPaths();

    const onAgreementComplete = () => {
        if (formRef.current) {
            formRef.current.submit();
        }
    };

    return (
        <>
            {isOwnerOrManagerState && (
                <AcknowledgementTermsAndConditions
                    onAgreementComplete={onAgreementComplete}
                    advisoriesApi={props.advisoriesApi}
                />
            )}
            <PostLoginSkeleton />
            <form
                action={applicationPaths.postLogin}
                method="POST"
                ref={formRef}>
                <input
                    type="hidden"
                    name="returnUrl"
                    id="returnUrl"
                    value={returnUrl}
                />
            </form>
        </>
    );
}

export function PostLoginSkeleton() {
    return (
        <>
            <Skeleton height="428px" />
            <MediaQuery query={`(min-width: ${Large}px)`}>
                {(isDesktop: boolean) => (
                    isDesktop ? <DesktopDashboardSkeleton /> : <MobileDashboardSkeleton />
                )}
            </MediaQuery>
            <MFContainer>
                <Skeleton height="20px" />
            </MFContainer>
            <ButtonContainer>
                <Skeleton height="344px" />
            </ButtonContainer>
        </>
    );
}

const PostLoginWithAuth = withAuth(PostLogin);
export default PostLoginWithAuth;